import { LessonHeader } from '@elearning-platform/ui';
import React from 'react';

import { ContentWrapper, LessonHeaderWrapper, Wrapper } from './slidesWrapper.styled';
import { SlidesWrapperProps } from './slidesWrapper.types';

export const SlidesWrapper: React.FC<SlidesWrapperProps> = (props: SlidesWrapperProps): JSX.Element => {
  const { moduleNumber, partTitle, slideTitle, children }: SlidesWrapperProps = props;

  return (
    <Wrapper>
      <LessonHeaderWrapper>
        <LessonHeader moduleNumber={moduleNumber} subtitle={slideTitle} title={partTitle} />
      </LessonHeaderWrapper>
      <ContentWrapper>
        {children}
      </ContentWrapper>
    </Wrapper>
  );
};
